import Keycloak from 'keycloak-js';
import { getEnvConfig } from '../getEnvConfig';
const keycloak = new Keycloak({
    url: getEnvConfig.KEYCLOAK_URL,
    realm: getEnvConfig.KEYCLOAK_REALM,
    clientId: getEnvConfig.KEYCLOAK_CLIEND_ID,
});

export default keycloak;
